import * as actionTypes from './_actionTypes';

export const fetchStudentProgressRequest = (filters = {}) => ({
  type: actionTypes.FETCH_STUDENT_PROGRESS_REQUEST,
  payload: filters,
});

export const fetchStudentProgressSuccess = (data) => ({
  type: actionTypes.FETCH_STUDENT_PROGRESS_SUCCESS,
  payload: data,
});

export const fetchStudentProgressFailure = (error) => ({
  type: actionTypes.FETCH_STUDENT_PROGRESS_FAILURE,
  payload: error,
});

export const exportProgressReportRequest = (filters = {}, format = 'json') => ({
  type: actionTypes.EXPORT_PROGRESS_REPORT_REQUEST,
  payload: { filters, format },
});

export const exportProgressReportSuccess = () => ({
  type: actionTypes.EXPORT_PROGRESS_REPORT_SUCCESS,
});

export const exportProgressReportFailure = (error) => ({
  type: actionTypes.EXPORT_PROGRESS_REPORT_FAILURE,
  payload: error,
});

export const setProgressFilters = (filters) => ({
  type: actionTypes.SET_PROGRESS_FILTERS,
  payload: filters,
});

export const clearProgressFilters = () => ({
  type: actionTypes.CLEAR_PROGRESS_FILTERS,
});
